import { createContext, useContext } from 'react';
import { useStore } from 'zustand';
import { SemanticSearchStoreType } from './semanticSearchStore';
import { SemanticSearchStore } from './semantic_search.store.types';

export const SemanticSearchStoreContext = createContext<SemanticSearchStoreType | null>(null);

export const useSemanticSearchStore = <T>(
    selector: (state: SemanticSearchStore) => T,
): T => {
    const store = useContext(SemanticSearchStoreContext);
    if (!store) {
        throw new Error('useSemanticSearchStore must be used within a SemanticSearchStoreProvider');
    }
    return useStore(store, selector);
};